import { Checkbox, Flex, Text } from '@shared/components';

import { useQBSLevelItemSelection } from '../../providers';
import { LevelItemAccordion } from '../accordion';

export default function QBSLevelItemSelection() {
  const {
    firstLevelItems,
    selectAll: { state: isSelectAllItems, change: handleSelectAll },
  } = useQBSLevelItemSelection();

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(3),
      })}
    >
      <Flex>
        <Text
          variant='h5'
          sx={{
            flex: 1,
          }}
        >
          เลือกเนื้อหาเพื่อกำหนดโครงสร้างข้อสอบ
        </Text>
        <Checkbox
          label='Select All'
          onChange={(e) => handleSelectAll(e.target.checked)}
          value={isSelectAllItems.checked}
          indeterminate={isSelectAllItems.indeterminate}
          sx={(theme) => ({
            p: theme.spacing(0),
            color: theme.palette.grey[400],
          })}
          slotProps={{
            formControlLabel: {
              sx: (theme) => ({
                gap: theme.spacing(2),
              }),
            },
          }}
        />
      </Flex>

      {firstLevelItems.map((item) => {
        return (
          <Flex
            key={item.id}
            sx={(theme) => ({
              borderRadius: theme.shape.rounded(2),
              border: '1px solid',
              borderColor: theme.palette.grey[300],
              flexDirection: 'column',
              overflow: 'hidden',
            })}
          >
            <LevelItemAccordion item={item} />
          </Flex>
        );
      })}
    </Flex>
  );
}
